import React from "react";
interface InfoBoxProps {
  title: string;
  value: string;
  description: string;
  gradientFrom: string;
  gradientTo: string;
}
export function InfoBox({
  title,
  value,
  description,
  gradientFrom,
  gradientTo
}: InfoBoxProps) {
  return <div className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradientFrom} ${gradientTo} group`} data-id="element-514">
      <div className="relative p-6 bg-black/90 rounded-lg h-full" data-id="element-515">
        <div className="space-y-4" data-id="element-516">
          <h3 className="text-gray-400 font-medium text-sm" data-id="element-517">{title}</h3>
          <p className="text-3xl font-bold text-white" data-id="element-518">{value}</p>
          <p className="text-gray-400 text-sm" data-id="element-519">{description}</p>
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out" data-id="element-520" />
      </div>
    </div>;
}